<div class="wrapper">
  <div class="left">
    
    @if (match.cameras?.length) {
      <ion-icon color="success" class="icon" slot="icon-only" name="videocam"></ion-icon>
    }
    @if (match.videoBoards?.length) {
      <ion-icon color="success" class="icon" slot="icon-only" name="tv"></ion-icon>
    }
    
    <!-- Show tie position -->
    @if (match.collectionPosition) {
      <span>#{{ match.collectionPosition }}</span>
      <span style="padding: 0 3px;">|</span>
    }

    <!-- Show match duration -->
    @if (match.matchStatus === 'SUSPENDED') {
      <ion-badge color="warning" mode="ios" outline="true">
        <ion-label>Suspended</ion-label>
      </ion-badge>
    } @else {
      @if (match.source?.partner?.toLowerCase() === 'tmx') {
        <span class="text">{{ scoreboardService.getMatchTime(match) }}</span>
      } @else {
        <span><app-match-duration [match]="match"></app-match-duration></span>
      }
      <!-- Show court name -->
      @if (scoreboardService.getCourtName(match)) {
        <span style="padding: 0 3px;">|</span>
        <span class="text">{{ scoreboardService.getCourtName(match) }}</span>
      }
    }



    <!-- Order of finish -->
    @if (match.orderOfFinish) {
      <span style="padding: 0 3px;">|</span>
      <span class="text">Order of finish: {{ match.orderOfFinish }}</span>
    }
  
  </div>


  <div>
    <!-- Weather -->
    @if (match?.weather?.main) {
      <span class="text" >{{ matchService.getWeatherInfo(match) }}</span>
    }

    <!-- Tournament round -->
    @if (match?.tournament) {
      <span style="padding: 0 3px;">|</span>
      <span class="text"> {{ match.event?.eventName | eventName }} - {{ match.roundName }}</span>      
    }
  </div>

  <div *ngIf="showBattery">
    <app-battery-indicator [match]="match"></app-battery-indicator>
  </div>

</div>